import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { motion } from "framer-motion";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const PastIssues = () => {
  const navigate = useNavigate();
  const [issues, setIssues] = useState([]);

  useEffect(() => {
    axios.get(`${API}/issues`).then((r) => setIssues(r.data));
  }, []);

  return (
    <section
      id="issues"
      data-testid="issues-section"
      className="bg-[#f5f5f5] px-4 md:px-8 lg:px-12 py-24 md:py-32"
    >
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14 md:mb-20">
        <div>
          <span className="font-accent uppercase text-xs tracking-[0.3em] text-[#4a4a4a]">
            The Archive
          </span>
          <h2 className="font-serif-display text-5xl md:text-7xl tracking-tight leading-[0.9] mt-3">
            Past
            <br />
            <span className="italic font-light">Issues</span>
          </h2>
        </div>
        <p className="max-w-sm font-light text-[#4a4a4a] leading-relaxed">
          Every issue is a collector's object — covers shot on location, pages
          built around the photograph.
        </p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 md:gap-8">
        {issues.map((issue, i) => (
          <motion.article
            key={issue.id}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.08 }}
            onClick={() => navigate(`/issue/${issue.id}`)}
            data-testid={`issue-card-${issue.id}`}
            className="group cursor-pointer"
          >
            <div className="relative aspect-[3/4] overflow-hidden bg-black">
              <img
                src={issue.cover}
                alt={issue.title}
                className="h-full w-full object-cover opacity-95 transition-transform duration-[1.2s] ease-out group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
              <div className="absolute top-4 left-4 right-4 flex items-center justify-between text-white">
                <span className="font-serif-display italic text-lg">TJ</span>
                <span className="font-accent uppercase text-[10px] tracking-[0.2em]">
                  {issue.season} {issue.year}
                </span>
              </div>
              <div className="absolute bottom-0 p-4">
                <h3 className="font-serif-display text-white text-2xl leading-tight">
                  {issue.title}
                </h3>
              </div>
            </div>
            <p className="mt-3 font-light text-sm text-[#4a4a4a] leading-relaxed">
              {issue.description}
            </p>
          </motion.article>
        ))}
      </div>
    </section>
  );
};

export default PastIssues;
